/**
 * Application Configuration
 * Provides runtime configuration based on hostname
 */

interface AppConfig {
  APP_OIDC_AUTHORITY: string;
  API_BASE_URL: string;
  BASE_HOME_URL: string;
  APP_HOME_URL: string;
  HOST: string;
  APP_OIDC_CLIENT_ID: string;
  APP_OIDC_SCOPE: string;
  APP_ALLOWED_DOMAINS: string;
  APP_INTERNAL_DOMAINS: string;
  APP_TRAINING_PORTAL: string;
  APP_VERSION: string;
  APP_CONTACT_US: string;
  APP_FEEDBACK: string;
  APP_IDLE_TIMEOUT_MINUTES: string;
  APP_API_TIMEOUT: string;
  APP_LONG_API_TIMEOUT: string;
  APP_ENABLE_TOKEN_REFRESH: string;
  APP_LOGOUT?: string;
  APP_MYACCOUNT_ENDPOINT?: string;
  B2C_LOGIN_URL?: string;
  B2C_1A_PARAMS?: string;
  SDA_CLIENT_ID_B2C?: string;
  WORKING_ENV: string;
}

export function getEnv(): AppConfig {
  const ENV_LEVEL_CONFIGURATION: Record<string, AppConfig> = {
    LOCAL: {
      APP_OIDC_AUTHORITY: 'https://dev2-fedsvc.solutions.iqvia.com/oauth2/oidcdiscovery',
      API_BASE_URL: 'https://10.3.68.157:8000',
      BASE_HOME_URL: 'https://localhost:3000',
      APP_HOME_URL: '',
      HOST: 'localhost',
      APP_OIDC_CLIENT_ID: 'RCG9VbNof0acgV4bAfSgi9eWyOga',
      APP_OIDC_SCOPE: 'openid profile email',
      APP_ALLOWED_DOMAINS: 'iqvia.com,quintiles.com,thinkingcap.com,clinspark.com,drugdev.com',
      APP_INTERNAL_DOMAINS: 'iqvia.com,quintiles.com',
      APP_TRAINING_PORTAL: 'https://connecteddevicestraining.thinkingcap.com/Login/Login.aspx',
      APP_VERSION: 'v1.0.0',
      APP_CONTACT_US: 'https://www.iqvia.com/contact/iqvia-contact-center/site-and-sponsor-technical-support',
      APP_FEEDBACK: 'https://iqvia.decipherinc.com/survey/selfserve/5e0/g9ee/250900?list=1',
      APP_IDLE_TIMEOUT_MINUTES: '2',
      // 30 000 ms — must be > backend httpx read timeout (60 s max, typically
      // 15–20 s under 650-user load). 15 000 ms fired before the backend
      // responded, causing "Token exchange failed: timeout of 15000ms exceeded".
      APP_API_TIMEOUT: '30000',
      APP_LONG_API_TIMEOUT: '60000',
      APP_ENABLE_TOKEN_REFRESH: 'true',
      APP_LOGOUT: 'https://dev2-fedsvc.solutions.iqvia.com/oidc/logout?',
      APP_MYACCOUNT_ENDPOINT:'https://dev2-myacct.solutions.iqvia.com/iqvia-persona-endpoint',
      B2C_LOGIN_URL: 'https://devbiqviaextid.b2clogin.com/devbiqviaextid.onmicrosoft.com/oauth2/v2.0/authorize',
      B2C_1A_PARAMS: 'B2C_1A_FEDMFA_IQVIAEditProfile',
      SDA_CLIENT_ID_B2C: 'b1526ed6-caad-4e4b-a327-caa408800740',
      WORKING_ENV: 'LOCAL',
    },
    DEV: {
      APP_OIDC_AUTHORITY: 'https://dev2-fedsvc.solutions.iqvia.com/oauth2/oidcdiscovery',
      API_BASE_URL: 'https://cddp-dev.solutions.iqvia.com/api',
      BASE_HOME_URL: 'https://cddp-dev.solutions.iqvia.com',
      APP_HOME_URL:'',
      HOST: 'cddp-dev.solutions.iqvia.com',
      APP_OIDC_CLIENT_ID: 'fQ2ZdA16KfpJm5IzeQmUGVVXGLca',
      APP_OIDC_SCOPE: 'openid profile email',
      APP_ALLOWED_DOMAINS:'iqvia.com,quintiles.com,thinkingcap.com,clinspark.com,drugdev.com',
      APP_INTERNAL_DOMAINS: 'iqvia.com,quintiles.com',
      APP_TRAINING_PORTAL:'https://connecteddevicestraining.thinkingcap.com/Login/Login.aspx',
      APP_VERSION:'v1.0.0',
      APP_CONTACT_US:'https://www.iqvia.com/contact/iqvia-contact-center/site-and-sponsor-technical-support',
      APP_FEEDBACK:'https://iqvia.decipherinc.com/survey/selfserve/5e0/g9ee/250900?list=1',
      APP_IDLE_TIMEOUT_MINUTES:'2',
      // 30 000 ms — same reason as LOCAL
      APP_API_TIMEOUT:'30000',
      APP_LONG_API_TIMEOUT:'60000',
      APP_ENABLE_TOKEN_REFRESH:'true',
      APP_MYACCOUNT_ENDPOINT:'https://dev2-myacct.solutions.iqvia.com/iqvia-persona-endpoint',
      B2C_LOGIN_URL: 'https://devbiqviaextid.b2clogin.com/devbiqviaextid.onmicrosoft.com/oauth2/v2.0/authorize',
      B2C_1A_PARAMS: 'B2C_1A_FEDMFA_IQVIAEditProfile',
      SDA_CLIENT_ID_B2C: 'b1526ed6-caad-4e4b-a327-caa408800740',
      WORKING_ENV: 'DEV',
      
    },
    DRT: {
      APP_OIDC_AUTHORITY: 'https://dev2-fedsvc.solutions.iqvia.com/oauth2/oidcdiscovery',
      API_BASE_URL: 'https://cddp-drt.solutions.iqvia.com/api',
      BASE_HOME_URL: 'https://cddp-drt.solutions.iqvia.com',
      APP_HOME_URL:'',
      HOST: 'cddp-drt.solutions.iqvia.com',
      APP_OIDC_CLIENT_ID: 'lDvWNKR6vFa5BxGejCH46PHVv6ca',
      APP_OIDC_SCOPE: 'openid profile email',
      APP_ALLOWED_DOMAINS:'iqvia.com,quintiles.com,thinkingcap.com,clinspark.com,drugdev.com',
      APP_INTERNAL_DOMAINS: 'iqvia.com,quintiles.com',
      APP_TRAINING_PORTAL:'https://connecteddevicestraining.thinkingcap.com/Login/Login.aspx',
      APP_VERSION:'v1.0.0',
      APP_CONTACT_US:'https://www.iqvia.com/contact/iqvia-contact-center/site-and-sponsor-technical-support',
      APP_FEEDBACK:'https://iqvia.decipherinc.com/survey/selfserve/5e0/g9ee/250900?list=1',
      APP_IDLE_TIMEOUT_MINUTES:'30',
      // 30 000 ms — same reason as LOCAL/DEV
      APP_API_TIMEOUT:'30000',
      APP_LONG_API_TIMEOUT:'60000',
      APP_ENABLE_TOKEN_REFRESH:'true',
      APP_MYACCOUNT_ENDPOINT:'https://dev2-myacct.solutions.iqvia.com/iqvia-persona-endpoint',
      B2C_LOGIN_URL: 'https://devbiqviaextid.b2clogin.com/devbiqviaextid.onmicrosoft.com/oauth2/v2.0/authorize',
      B2C_1A_PARAMS: 'B2C_1A_FEDMFA_IQVIAEditProfile',
      SDA_CLIENT_ID_B2C: 'b1526ed6-caad-4e4b-a327-caa408800740',
      WORKING_ENV: 'DRT'
    },
    SVT: {
      APP_OIDC_AUTHORITY: 'https://uat-fedsvc.solutions.iqvia.com/oauth2/oidcdiscovery',
      API_BASE_URL: 'https://cddp-svt.solutions.iqvia.com/api',
      BASE_HOME_URL: 'https://cddp-svt.solutions.iqvia.com',
      APP_HOME_URL:'',
      HOST: 'cddp-svt.solutions.iqvia.com',
      APP_OIDC_CLIENT_ID: 'ydk2ke4YTWb_IbUbNR1iwVkNoCga',
      APP_OIDC_SCOPE: 'openid profile email',
      APP_ALLOWED_DOMAINS:'iqvia.com,quintiles.com,thinkingcap.com,clinspark.com,drugdev.com',
      APP_INTERNAL_DOMAINS: 'iqvia.com,quintiles.com',
      APP_TRAINING_PORTAL:'https://connecteddevicestraining.thinkingcap.com/Login/Login.aspx',
      APP_VERSION:'v1.0.0',
      APP_CONTACT_US:'https://www.iqvia.com/contact/iqvia-contact-center/site-and-sponsor-technical-support',
      APP_FEEDBACK:'https://iqvia.decipherinc.com/survey/selfserve/5e0/g9ee/250900?list=1',
      APP_IDLE_TIMEOUT_MINUTES:'30',
      APP_API_TIMEOUT:'30000',
      APP_LONG_API_TIMEOUT:'60000',
      APP_ENABLE_TOKEN_REFRESH:'true',
      APP_MYACCOUNT_ENDPOINT:'https://uat-myacct.solutions.iqvia.com/iqvia-persona-endpoint',
      B2C_LOGIN_URL: 'https://testbiqviaextid.b2clogin.com/testbiqviaextid.onmicrosoft.com/oauth2/v2.0/authorize',
      B2C_1A_PARAMS: 'B2C_1A_FEDMFA_IQVIAEditProfile',
      SDA_CLIENT_ID_B2C: '51e517f3-836f-4d58-bef4-86db04e6549d',
      WORKING_ENV: 'SVT'
    },
    PERF: {
      APP_OIDC_AUTHORITY: 'https://uat-fedsvc.solutions.iqvia.com/oauth2/oidcdiscovery',
      API_BASE_URL: 'https://cddp-perf.solutions.iqvia.com/api',
      BASE_HOME_URL: 'https://cddp-perf.solutions.iqvia.com',
      APP_HOME_URL:'',
      HOST: 'cddp-perf.solutions.iqvia.com',
      APP_OIDC_CLIENT_ID: 'uyQG6RJR_hke9fu3WHffQS_H3FYa',
      APP_OIDC_SCOPE: 'openid profile email',
      APP_ALLOWED_DOMAINS:'iqvia.com,quintiles.com,thinkingcap.com,clinspark.com,drugdev.com',
      APP_INTERNAL_DOMAINS: 'iqvia.com,quintiles.com',
      APP_TRAINING_PORTAL:'https://connecteddevicestraining.thinkingcap.com/Login/Login.aspx',
      APP_VERSION:'v1.0.0',
      APP_CONTACT_US:'https://www.iqvia.com/contact/iqvia-contact-center/site-and-sponsor-technical-support',
      APP_FEEDBACK:'https://iqvia.decipherinc.com/survey/selfserve/5e0/g9ee/250900?list=1',
      APP_IDLE_TIMEOUT_MINUTES:'30',
      APP_API_TIMEOUT:'30000',
      APP_LONG_API_TIMEOUT:'60000',
      APP_ENABLE_TOKEN_REFRESH:'true',
      APP_MYACCOUNT_ENDPOINT:'https://uat-myacct.solutions.iqvia.com/iqvia-persona-endpoint',
      B2C_LOGIN_URL: 'https://testbiqviaextid.b2clogin.com/testbiqviaextid.onmicrosoft.com/oauth2/v2.0/authorize',
      B2C_1A_PARAMS: 'B2C_1A_FEDMFA_IQVIAEditProfile',
      SDA_CLIENT_ID_B2C: '51e517f3-836f-4d58-bef4-86db04e6549d',
      WORKING_ENV: 'PERF'
    },
    UAT: {
      APP_OIDC_AUTHORITY: 'https://uat-fedsvc.solutions.iqvia.com/oauth2/oidcdiscovery',
      API_BASE_URL: 'https://cddp-test.solutions.iqvia.com/api',
      BASE_HOME_URL: 'https://cddp-test.solutions.iqvia.com',
      APP_HOME_URL:'',
      HOST: 'cddp-test.solutions.iqvia.com',
      APP_OIDC_CLIENT_ID: '101x2LxNdw0Ch16Sbeef9mE_vI0a',
      APP_OIDC_SCOPE: 'openid profile email',
      APP_ALLOWED_DOMAINS:'iqvia.com,quintiles.com,thinkingcap.com,clinspark.com,drugdev.com',
      APP_INTERNAL_DOMAINS: 'iqvia.com,quintiles.com',
      APP_TRAINING_PORTAL:'https://connecteddevicestraining.thinkingcap.com/Login/Login.aspx',
      APP_VERSION:'v1.0.0',
      APP_CONTACT_US:'https://www.iqvia.com/contact/iqvia-contact-center/site-and-sponsor-technical-support',
      APP_FEEDBACK:'https://iqvia.decipherinc.com/survey/selfserve/5e0/g9ee/250900?list=1',
      APP_IDLE_TIMEOUT_MINUTES:'30',
      // 30 000 ms — same reason as LOCAL/DEV/DRT
      APP_API_TIMEOUT:'30000',
      APP_LONG_API_TIMEOUT:'60000',
      APP_ENABLE_TOKEN_REFRESH:'true',
      APP_MYACCOUNT_ENDPOINT:'https://uat-myacct.solutions.iqvia.com/iqvia-persona-endpoint',
      B2C_LOGIN_URL: 'https://testbiqviaextid.b2clogin.com/testbiqviaextid.onmicrosoft.com/oauth2/v2.0/authorize',
      B2C_1A_PARAMS: 'B2C_1A_FEDMFA_IQVIAEditProfile',
      SDA_CLIENT_ID_B2C: '51e517f3-836f-4d58-bef4-86db04e6549d',
      WORKING_ENV: 'UAT',
      
    },
    PROD: {
      APP_OIDC_AUTHORITY: 'https://fedsvc.myaccount.iqvia.com/oauth2/oidcdiscovery',
      API_BASE_URL: 'https://cddp.solutions.iqvia.com/api',
      BASE_HOME_URL: 'https://cddp.solutions.iqvia.com',
      APP_HOME_URL:'',
      HOST: 'cddp.solutions.iqvia.com',
      APP_OIDC_CLIENT_ID: 'XHrDirAEauXuEpqWIWZVby48fu4a',
      APP_OIDC_SCOPE: 'openid profile email',
      APP_ALLOWED_DOMAINS:'iqvia.com,quintiles.com,thinkingcap.com,clinspark.com,drugdev.com',
      APP_INTERNAL_DOMAINS: 'iqvia.com,quintiles.com',
      APP_TRAINING_PORTAL:'https://connecteddevicestraining.thinkingcap.com/Login/Login.aspx',
      APP_VERSION:'v1.0.0',
      APP_CONTACT_US:'https://www.iqvia.com/contact/iqvia-contact-center/site-and-sponsor-technical-support',
      APP_FEEDBACK:'https://iqvia.decipherinc.com/survey/selfserve/5e0/g9ee/250900?list=1',
      APP_IDLE_TIMEOUT_MINUTES:'30',
      // Increased from 15000 to 30000ms:
      // The backend OIDC call to Azure AD takes up to 20s under 650+ user load.
      // A 15s frontend timeout fires BEFORE the backend responds, causing the
      // "Token exchange failed: timeout of 15000ms exceeded" error.
      APP_API_TIMEOUT:'30000',
      APP_LONG_API_TIMEOUT:'60000',
      APP_ENABLE_TOKEN_REFRESH:'true',
      APP_MYACCOUNT_ENDPOINT:'https://myacct.myaccount.iqvia.com/iqvia-persona-endpoint',
      B2C_LOGIN_URL: 'https://iqviaextidm.b2clogin.com/iqviaextidm.onmicrosoft.com/oauth2/v2.0/authorize',
      B2C_1A_PARAMS: 'B2C_1A_FEDMFA_IQVIAEditProfile',
      SDA_CLIENT_ID_B2C: '8e47c384-3b17-43fe-add0-1dbf87d62c5e',
      WORKING_ENV: 'PROD',
      
    },
  };
  const hostName = window.location.hostname;
  let envConfigs: AppConfig;

  switch (hostName) {
    case ENV_LEVEL_CONFIGURATION.LOCAL.HOST:
      envConfigs = ENV_LEVEL_CONFIGURATION.LOCAL;
      break;
    case ENV_LEVEL_CONFIGURATION.DEV.HOST:
      envConfigs = ENV_LEVEL_CONFIGURATION.DEV;
      break;
    case ENV_LEVEL_CONFIGURATION.DRT.HOST:
      envConfigs = ENV_LEVEL_CONFIGURATION.DRT;
      break;
    case ENV_LEVEL_CONFIGURATION.SVT.HOST:
      envConfigs = ENV_LEVEL_CONFIGURATION.SVT;
      break;
    case ENV_LEVEL_CONFIGURATION.PERF.HOST:
      envConfigs = ENV_LEVEL_CONFIGURATION.PERF;
      break;
    case ENV_LEVEL_CONFIGURATION.UAT.HOST:
      envConfigs = ENV_LEVEL_CONFIGURATION.UAT;
      break;
    case ENV_LEVEL_CONFIGURATION.PROD.HOST:
      envConfigs = ENV_LEVEL_CONFIGURATION.PROD;
      break;
    default:
      console.warn(`Unknown hostname: ${hostName}, falling back to LOCAL config`);
      envConfigs = ENV_LEVEL_CONFIGURATION.LOCAL;
      break;
  }

  return envConfigs;
}

// Cache the config to avoid multiple calls
let cachedConfig: AppConfig | null = null;

export function getAppConfig(): AppConfig {
  if (!cachedConfig) {
    cachedConfig = getEnv();
    console.log('[CONFIG] Loaded configuration for:', cachedConfig.WORKING_ENV);
  }
  return cachedConfig;
}

// Export singleton instance for easy access
export const appConfig = getAppConfig();

// Helper functions for common operations
export const parseDomains = (domains: string): string[] => {
  return domains.split(',').map(d => d.trim()).filter(Boolean);
};

export const isDomainAllowed = (domain: string): boolean => {
  const allowedDomains = parseDomains(appConfig.APP_ALLOWED_DOMAINS);
  return allowedDomains.some(
    allowedDomain => domain.toLowerCase().endsWith(allowedDomain.toLowerCase())
  );
};

export const isInternalDomain = (domain: string): boolean => {
  const internalDomains = parseDomains(appConfig.APP_INTERNAL_DOMAINS);
  return internalDomains.some(
    internalDomain => domain.toLowerCase().endsWith(internalDomain.toLowerCase())
  );
};

export const getLogoutUrl = (redirectUri?: string): string => {
  const redirect = redirectUri || `${window.location.origin}${appConfig.APP_HOME_URL}`;
  const logoutUrl = appConfig.APP_LOGOUT || 'https://dev2-fedsvc.solutions.iqvia.com/oidc/logout?';
  return `${logoutUrl}post_logout_redirect_uri=${encodeURIComponent(redirect)}`;
};

export const getIdleTimeoutMs = (): number => {
  return parseInt(appConfig.APP_IDLE_TIMEOUT_MINUTES, 10) * 60 * 1000;
};

export const getApiTimeout = (): number => {
  return parseInt(appConfig.APP_API_TIMEOUT, 10);
};

export const getLongApiTimeout = (): number => {
  return parseInt(appConfig.APP_LONG_API_TIMEOUT, 10);
};

export const isTokenRefreshEnabled = (): boolean => {
  return appConfig.APP_ENABLE_TOKEN_REFRESH === 'true';
};

// Export default for convenience
export default appConfig;